/**
 * Google places API doesn't provide information about country and countryId for Palestinian cities (political reasons).
 * Below are the cities copied from here: https://en.wikipedia.org/wiki/List_of_cities_in_Palestine
 * The places ids are copied from here: https://developers.google.com/maps/documentation/javascript/place-autocomplete-new#example-maps
 * The country id is copied from the existing data in the database and also checked in a different google api: https://developers.google.com/hotels/hotel-prices/dev-guide/country-codes
 *
 * The map below is implemented in a way that can allow adding other countries and their ids in similar cases.
 */

type SimplifiedPlaceType = {
  city: string;
  country: string;
  countryId: string;
};

export const additionalPlacesInfoMap = new Map<string, SimplifiedPlaceType>([
  [
    "ChIJ9SmkxTKO_RQRKR1wdgkQ1pE",
    {
      city: "Abasan al-Kabira",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJgy09kqopAxURL_4talKgMtY",
    {
      city: "Abu Dis",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJ44-EJ3zhAhURDw8k_aZvFz0",
    {
      city: "Bani Na'im",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJp3_P1CWQ_RQR1r8XJnrruyk",
    {
      city: "Bani Suheila",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJjUX6eo6BAhURCBYeQR4kULI",
    {
      city: "Beit Hanoun",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJG1dFnETYAhURc8pEC3CXOGU",
    {
      city: "Bayt Jala",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJf-80Pf6BAhURopT6G4mbWe4",
    {
      city: "Beit Lahia",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJdw8dCpsnAxURz-SjMfVWwFc",
    {
      city: "Bayt Sahur",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJCyHq9ZLdAhURLl-O9PfmmE0",
    {
      city: "Beit Ummar",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJueiM4d_UAhURrUMzt8YAvak",
    {
      city: "Beitunia",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJZw3IrmXYAhUR-PG65D0hxPU",
    {
      city: "Bethlehem",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJkS-til3VHBURpJMoXYMfB5Q",
    {
      city: "Al-Bireh",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJRaA9KcKE_RQRhw40NIiGPIw",
    {
      city: "Deir al Balah",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJO4HvH8v2AhURcicFD_oIT4Y",
    {
      city: "ad-Dhahiriya",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJK7b1q5rvAhURrpvNb9pmdJA",
    {
      city: "Dura",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJZydUTgV__RQRkmMEE8mN-X8",
    {
      city: "Gaza",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJmdBw-xjnAhURgaDWgn-PG04",
    {
      city: "Halhul",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJ-2PE7CfkAhURTBMvalxNRr4",
    {
      city: "Hebron",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJjfxiM8TuAhURpQKxXGq5lDo",
    {
      city: "Idhna",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJuQdno05-_RQR7KM6byDvMx8",
    {
      city: "Jabalia",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJp1lUUtX-HBURpOkjwfjq8oo",
    {
      city: "Jenin",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJZ4X_5mHMHBURu2hWaKQoFIE",
    {
      city: "Jericho",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJJdDs4kSQ_RQRb9KLWJE7tbQ",
    {
      city: "Khan Yunis",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJl1ZCUPbgHBURhD0VvTCpC38",
    {
      city: "Nablus",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJ8a2cGkD8HBURwDvqlRlTTz8",
    {
      city: "Qabatiya",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJDTLnSJA7HRURB9zZ5ROM0I4",
    {
      city: "Qalqilya",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJK-jM2Y-T_RQRf7RMkGJoBfg",
    {
      city: "Rafah",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJ0Vgt2kzVAhURdiyLzBdNbb8",
    {
      city: "Ramallah",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJv5xF3GjgAhURgQfqx68iKpQ",
    {
      city: "Sa'Ir",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJn22svD76AhURRpI9_IdHEts",
    {
      city: "as-Samu",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJXw_C6xbdAhURwHUo_uqCBZs",
    {
      city: "Surif",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJv5xF3GjgAhURgQfqx68iKpQ",
    {
      city: "Sa'Ir",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJ1T4hxbb6HBURVrmX7Xy2U_0",
    {
      city: "Tubas",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJWdQhXZ0XHRURpgHAcVpCx2s",
    {
      city: "Tulkarm",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJi4T_cMoDHRURrbxobef2mCA",
    {
      city: "Ya'bad",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJp9FRBMv_HBURxfx360s06co",
    {
      city: "Yamun",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJw93xoTr7AhURjGK7Uujmf9g",
    {
      city: "Yatta",
      country: "Palestine",
      countryId: "PS",
    },
  ],
  [
    "ChIJm6D-kIaE_RQRKk0-J17Lo7Q",
    {
      city: "Az Zawayda",
      country: "Palestine",
      countryId: "PS",
    },
  ],
]);
